import React from 'react';
import { useChatContext } from 'stream-chat-react';

const routes = [
    ["List", ""],
    ["Shortcuts", "new/shortcuts"],
    ["NewServices", "new/services"],
    ["NewGroups", "new/groups"],
    ["Conversation", "conversations/:id"],
    ["Details", "conversations/:id/details"],
    ["NewServicesPlan", "new/services/plans/:plan_id/teams/:teams"],
    ["NewServicesTeam", "new/services/teams/:teams"],
    ["BlankState", "blankstate"],
];
const findRoute = (path) => {
    path !== null && path !== undefined ? path : (path = "");
    const pathParts = path.split("/");
    const match = routes.find(([, route]) => {
        const routeParts = route.split("/");
        return (pathParts.length === routeParts.length &&
            routeParts.every((routePart, index) => routePart.startsWith(":") || routePart === pathParts[index]));
    });
    if (!match)
        return null;
    const [name, route] = match;
    const params = route
        .split("/")
        .reduce((acc, routePart, index) => routePart.startsWith(":")
        ? { ...acc, [routePart.slice(1)]: pathParts[index] }
        : acc, {});
    return {
        index: routes.indexOf(match),
        name,
        params,
        path: (ps = params) => route
            .split("/")
            .reduce((acc, routePart) => [
            ...acc,
            routePart.startsWith(":") ? ps[routePart.slice(1)] : routePart,
        ], [])
            .join("/"),
    };
};
const useChatNavigation = ({ currentPath, onChangePath, setFilterValues, }) => {
    const { client, channel, setActiveChannel } = useChatContext();
    const [activeIndex, setActiveIndex] = React.useState(() => {
        const route = currentPath && findRoute(currentPath);
        return route ? route.index : 0;
    });
    const switchToChannelListView = () => onChangePath("");
    const switchToNewChatShortcutsView = () => onChangePath("new/shortcuts");
    const switchToNewServicesChatView = () => onChangePath("new/services");
    const switchToNewGroupsChatView = () => onChangePath("new/groups");
    const switchToChannelView = (id) => onChangePath(`conversations/${id}`);
    const switchToChannelDetailsView = () => onChangePath(`conversations/${channel.id}/details`);
    const isChannelListViewActive = activeIndex === 0;
    const isNewChatShortcutsViewActive = activeIndex === 1;
    const isNewServicesChatViewActive = activeIndex === 2;
    const isNewGroupsChatViewActive = activeIndex === 3;
    const isChannelViewActive = activeIndex === 4;
    const isChannelDetailsViewActive = activeIndex === 5;
    const isBlankStateActive = activeIndex === 8;
    const findMostActiveChannel = React.useCallback(async (ids) => {
        const [channel] = await client.queryChannels({
            id: { $in: ids },
            members: { $in: [client.userID] },
            type: "messaging",
        }, { last_message_at: -1 }, { limit: 1 });
        return channel;
    }, [client]);
    const queryChannelAndSetActiveIndex = React.useCallback(async (route) => {
        const ids = route.params.id.split(",");
        const channel = await findMostActiveChannel(ids);
        if (!channel) {
            return switchToChannelListView();
        }
        setActiveChannel(channel);
        ids.length > 1
            ? onChangePath(route.path({ id: channel.id }))
            : setActiveIndex(route.index);
    }, [client]);
    React.useEffect(() => {
        const route = findRoute(currentPath);
        switch (route === null || route === undefined ? undefined : route.name) {
            case "BlankState": {
                setActiveIndex(route.index);
                break;
            }
            case "List": {
                setActiveIndex(route.index);
                channel && setActiveChannel(null);
                break;
            }
            case "Shortcuts":
            case "NewServices":
            case "NewGroups":
                setActiveIndex(route.index);
                break;
            case "NewServicesPlan":
            case "NewServicesTeam": {
                const { plan_id = null, teams } = route.params;
                setFilterValues({
                    appName: "Services",
                    values: {
                        plan_id: plan_id && parseInt(plan_id),
                        teams: teams
                            .split(",")
                            .map((team) => team.split(":"))
                            .map(([service_type_id, team_id]) => ({
                            service_type_id: parseInt(service_type_id),
                            team_id: parseInt(team_id),
                        })),
                    },
                });
                switchToNewServicesChatView();
                break;
            }
            case "Conversation":
            case "Details": {
                if (channel && channel.id === route.params.id) {
                    setActiveIndex(route.index);
                }
                else {
                    queryChannelAndSetActiveIndex(route);
                }
                break;
            }
            default:
                switchToChannelListView();
        }
    }, [currentPath, onChangePath]);
    return {
        activeIndex,
        isBlankStateActive,
        isChannelDetailsViewActive,
        isChannelListViewActive,
        isChannelViewActive,
        isNewChatShortcutsViewActive,
        isNewGroupsChatViewActive,
        isNewServicesChatViewActive,
        switchToChannelDetailsView,
        switchToChannelListView,
        switchToChannelView,
        switchToNewChatShortcutsView,
        switchToNewGroupsChatView,
        switchToNewServicesChatView,
    };
};

export { useChatNavigation };
//# sourceMappingURL=use_chat_navigation.js.map
